// Mock data for ChainKart luxury waitlist page

export const LOGO_URL = 'https://customer-assets-agu9un31.emergentagent.net/job_hybrid-app-test/artifacts/b1ww93jh_logo-lockup-light.jpg';

export const cryptoTickerData = [
  { symbol: 'BTC', price: '65,907.20', change: '0.60', color: '#F7931A' },
  { symbol: 'ETH', price: '1,923.82', change: '0.90', color: '#627EEA' },
  { symbol: 'SOL', price: '77.47', change: '1.12', color: '#14F195' },
  { symbol: 'BNB', price: '570.74', change: '1.27', color: '#F3BA2F' },
  { symbol: 'XRP', price: '1.14', change: '-0.27', color: '#4B5563' },
  { symbol: 'ADA', price: '0.1732', change: '0.71', color: '#0033AD' },
  { symbol: 'DOGE', price: '0.0725', change: '1.34', color: '#C2A633' },
  { symbol: 'USDC', price: '0.9999', change: '0.00', color: '#2775CA' },
  { symbol: 'LINK', price: '8.61', change: '-1.06', color: '#2A5ADA' },
  { symbol: 'DOT', price: '0.8378', change: '3.28', color: '#E6007A' },
  { symbol: 'AVAX', price: '24.15', change: '2.11', color: '#E84142' },
  { symbol: 'MATIC', price: '0.4562', change: '0.83', color: '#8247E5' },
];

export const features = [
  {
    id: 'brands',
    title: 'Shop luxury brands with crypto',
    description: 'From hype-drop sneakers to Swiss horology and haute couture \u2014 pay directly with ETH, SOL, BTC or USDC. Fully verified merchants only.',
    image: 'https://images.unsplash.com/photo-1551113006-731674fbb3ff?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBmYXNoaW9uJTIwZGFya3xlbnwwfHx8fDE3ODQ3OTcyNjJ8MA&ixlib=rb-4.1.0&q=85',
    tag: 'Verified Luxury',
  },
  {
    id: 'streams',
    title: 'Live shopping streams & events',
    description: 'Tune in to exclusive drops hosted by top brands and tastemakers. Cop the piece the moment it hits the screen \u2014 in one tap, on chain.',
    image: 'https://images.unsplash.com/photo-1594394489098-74ac04c0fc2e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHw0fHxsaXZlJTIwc3RyZWFtaW5nJTIwc3R1ZGlvfGVufDB8fHx8MTc4NDc5NzI2Mnww&ixlib=rb-4.1.0&q=85',
    tag: 'Live Now',
  },
  {
    id: 'auctions',
    title: 'Bid in live & timed auctions',
    description: 'Rare grails. Unreleased pieces. One-of-ones. Compete in real-time or place stealth bids on timed auctions \u2014 every hammer settles on-chain.',
    image: 'https://images.unsplash.com/photo-1676181739859-08330dea8999?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwyfHxhdWN0aW9uJTIwaGFtbWVyfGVufDB8fHx8MTc4NDc5NzI2Mnww&ixlib=rb-4.1.0&q=85',
    tag: 'Rare & Exclusive',
  },
];

export const foundingBenefits = [
  {
    title: 'Priority access',
    description: 'Skip the queue when the doors open. Founding members are the first to browse, shop and check out.',
    icon: 'Rocket',
  },
  {
    title: 'First-drop invitations',
    description: 'Exclusive invites to inaugural brand drops, private live-shopping streams, and members-only auctions.',
    icon: 'Ticket',
  },
  {
    title: 'Lifetime badge',
    description: 'A permanent Founding Member badge on your profile \u2014 recognized across every event, forever.',
    icon: 'BadgeCheck',
  },
];

export const waitlistStats = [
  { value: '12,847', label: 'Crypto holders on the list' },
  { value: '38', label: 'Luxury houses onboarded' },
  { value: '$14M+', label: 'Wallet volume ready to spend' },
];
